import React, { FC, memo, useCallback } from 'react';
import { makeStyles, mergeClasses, tokens } from '@fluentui/react-components';
import { Suggestion, SuggestionList } from '@fluentai/suggestions';

const useChatSuggestionStyles = makeStyles({
  suggestionList: {
    marginTop: tokens.spacingVerticalL,
  },
  suggestion: {
    backgroundColor: tokens.colorTransparentBackground,
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    justifyContent: 'left',
    display: 'inline-block',
  },
});

export interface IChatSuggestion {
  Text: string;
  Id: string;
}

interface IChatSuggestionListProps {
  chatSuggestions?: IChatSuggestion[];
  onClickChatSuggestion: (chatSuggestion: IChatSuggestion) => void;
}

export const ChatSuggestionList: FC<IChatSuggestionListProps> = memo(({
  chatSuggestions = [],
  onClickChatSuggestion,
}) => {
  const styles = useChatSuggestionStyles();

  const onClick = useCallback((chatSuggestion: IChatSuggestion) => {
    onClickChatSuggestion(chatSuggestion);
  }, [onClickChatSuggestion]);

  return (
    <SuggestionList
      className={mergeClasses(styles.suggestionList, 'ads-copilot-chat-suggestion-list')}
    >
      {chatSuggestions?.map((chatSuggestion) => (
        <Suggestion
          key={chatSuggestion.Id}
          className={mergeClasses(styles.suggestion, 'ads-copilot-chat-suggestion')}
          onClick={() => onClick(chatSuggestion)}
        >
          <span title={chatSuggestion.Text}>
            {chatSuggestion.Text}
          </span>
        </Suggestion>
      ))}
    </SuggestionList>
  );
});

ChatSuggestionList.defaultProps = {
  chatSuggestions: undefined,
  onClickChatSuggestion: undefined,
};
